import { API_PATH } from '../../routes/managePath';

export const ORGANIZATION_FUTURE_PATH = {
  INDEX: API_PATH.ORGANIZATION_FUTURE,
  CREATE: API_PATH.ORGANIZATION_FUTURE + '/create',
  DETAIL: API_PATH.ORGANIZATION_FUTURE + '/:id',
};
